/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AddTracksToAlbumDto,
  AlbumTrackAssetOptionDto,
  AlbumVideoDto,
  AlbumVideoPresignRequestDto,
  AlbumVideoPresignResponseDto,
  AlbumsControllerAlbumDetailParams,
  AlbumsControllerAlbumUploadBannerBody,
  AlbumsControllerAlbumUploadPictureBody,
  AlbumsControllerAlbumsBulkDeleteBody,
  AlbumsControllerAlbumsList200,
  AlbumsControllerAlbumsListParams,
  CreateAlbumDto,
  CreateAlbumResponseDto,
  DetailAlbumDto,
  ListAlbumDto,
  RegisterAlbumVideoDto,
  SetAlbumTrackAssetsDto,
  UpdateAlbumDto,
  UpdateAlbumTracksDto,
} from ".././dtos";

import { apiRequest } from "../../api-request";
import type { ErrorType, BodyType } from "../../api-request";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Create a new album
 */
export const albumsControllerAlbumCreate = (
  createAlbumDto: BodyType<CreateAlbumDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<CreateAlbumResponseDto>(
    {
      url: `/albums`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createAlbumDto,
      signal,
    },
    options,
  );
};

export const getAlbumsControllerAlbumCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumCreate>>,
    TError,
    { data: BodyType<CreateAlbumDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumCreate>>,
  TError,
  { data: BodyType<CreateAlbumDto> },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumCreate>>,
    { data: BodyType<CreateAlbumDto> }
  > = (props) => {
    const { data } = props ?? {};

    return albumsControllerAlbumCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumCreate>>
>;
export type AlbumsControllerAlbumCreateMutationBody = BodyType<CreateAlbumDto>;
export type AlbumsControllerAlbumCreateMutationError = ErrorType<unknown>;

/**
 * @summary Create a new album
 */
export const useAlbumsControllerAlbumCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumCreate>>,
      TError,
      { data: BodyType<CreateAlbumDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumCreate>>,
  TError,
  { data: BodyType<CreateAlbumDto> },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List albums
 */
export const albumsControllerAlbumsList = (
  params?: AlbumsControllerAlbumsListParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AlbumsControllerAlbumsList200>(
    { url: `/albums`, method: "GET", params, signal },
    options,
  );
};

export const getAlbumsControllerAlbumsListQueryKey = (
  params?: AlbumsControllerAlbumsListParams,
) => {
  return [`/albums`, ...(params ? [params] : [])] as const;
};

export const getAlbumsControllerAlbumsListQueryOptions = <
  TData = Awaited<ReturnType<typeof albumsControllerAlbumsList>>,
  TError = ErrorType<unknown>,
>(
  params?: AlbumsControllerAlbumsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAlbumsControllerAlbumsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumsList>>
  > = ({ signal }) =>
    albumsControllerAlbumsList(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AlbumsControllerAlbumsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumsList>>
>;
export type AlbumsControllerAlbumsListQueryError = ErrorType<unknown>;

export function useAlbumsControllerAlbumsList<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | AlbumsControllerAlbumsListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumsList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof albumsControllerAlbumsList>>,
          TError,
          Awaited<ReturnType<typeof albumsControllerAlbumsList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useAlbumsControllerAlbumsList<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumsList>>,
  TError = ErrorType<unknown>,
>(
  params?: AlbumsControllerAlbumsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumsList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof albumsControllerAlbumsList>>,
          TError,
          Awaited<ReturnType<typeof albumsControllerAlbumsList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAlbumsControllerAlbumsList<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumsList>>,
  TError = ErrorType<unknown>,
>(
  params?: AlbumsControllerAlbumsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List albums
 */

export function useAlbumsControllerAlbumsList<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumsList>>,
  TError = ErrorType<unknown>,
>(
  params?: AlbumsControllerAlbumsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAlbumsControllerAlbumsListQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update an album
 */
export const albumsControllerAlbumUpdate = (
  updateAlbumDto: BodyType<UpdateAlbumDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    {
      url: `/albums`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateAlbumDto,
    },
    options,
  );
};

export const getAlbumsControllerAlbumUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumUpdate>>,
    TError,
    { data: BodyType<UpdateAlbumDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumUpdate>>,
  TError,
  { data: BodyType<UpdateAlbumDto> },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumUpdate>>,
    { data: BodyType<UpdateAlbumDto> }
  > = (props) => {
    const { data } = props ?? {};

    return albumsControllerAlbumUpdate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumUpdate>>
>;
export type AlbumsControllerAlbumUpdateMutationBody = BodyType<UpdateAlbumDto>;
export type AlbumsControllerAlbumUpdateMutationError = ErrorType<unknown>;

/**
 * @summary Update an album
 */
export const useAlbumsControllerAlbumUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumUpdate>>,
      TError,
      { data: BodyType<UpdateAlbumDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumUpdate>>,
  TError,
  { data: BodyType<UpdateAlbumDto> },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete multiple albums
 */
export const albumsControllerAlbumsBulkDelete = (
  albumsControllerAlbumsBulkDeleteBody: BodyType<AlbumsControllerAlbumsBulkDeleteBody>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    {
      url: `/albums`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: albumsControllerAlbumsBulkDeleteBody,
    },
    options,
  );
};

export const getAlbumsControllerAlbumsBulkDeleteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumsBulkDelete>>,
    TError,
    { data: BodyType<AlbumsControllerAlbumsBulkDeleteBody> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumsBulkDelete>>,
  TError,
  { data: BodyType<AlbumsControllerAlbumsBulkDeleteBody> },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumsBulkDelete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumsBulkDelete>>,
    { data: BodyType<AlbumsControllerAlbumsBulkDeleteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return albumsControllerAlbumsBulkDelete(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumsBulkDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumsBulkDelete>>
>;
export type AlbumsControllerAlbumsBulkDeleteMutationBody =
  BodyType<AlbumsControllerAlbumsBulkDeleteBody>;
export type AlbumsControllerAlbumsBulkDeleteMutationError = ErrorType<unknown>;

/**
 * @summary Delete multiple albums
 */
export const useAlbumsControllerAlbumsBulkDelete = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumsBulkDelete>>,
      TError,
      { data: BodyType<AlbumsControllerAlbumsBulkDeleteBody> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumsBulkDelete>>,
  TError,
  { data: BodyType<AlbumsControllerAlbumsBulkDeleteBody> },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumsBulkDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get top trending albums
 */
export const albumsControllerTrendingAlbums = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ListAlbumDto[]>(
    { url: `/albums/trending`, method: "GET", signal },
    options,
  );
};

export const getAlbumsControllerTrendingAlbumsQueryKey = () => {
  return [`/albums/trending`] as const;
};

export const getAlbumsControllerTrendingAlbumsQueryOptions = <
  TData = Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAlbumsControllerTrendingAlbumsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>
  > = ({ signal }) => albumsControllerTrendingAlbums(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AlbumsControllerTrendingAlbumsQueryResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>
>;
export type AlbumsControllerTrendingAlbumsQueryError = ErrorType<unknown>;

export function useAlbumsControllerTrendingAlbums<
  TData = Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>,
          TError,
          Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useAlbumsControllerTrendingAlbums<
  TData = Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>,
          TError,
          Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAlbumsControllerTrendingAlbums<
  TData = Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get top trending albums
 */

export function useAlbumsControllerTrendingAlbums<
  TData = Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerTrendingAlbums>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAlbumsControllerTrendingAlbumsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get curated homepage albums
 */
export const albumsControllerHomepageAlbums = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ListAlbumDto[]>(
    { url: `/albums/homepage`, method: "GET", signal },
    options,
  );
};

export const getAlbumsControllerHomepageAlbumsQueryKey = () => {
  return [`/albums/homepage`] as const;
};

export const getAlbumsControllerHomepageAlbumsQueryOptions = <
  TData = Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAlbumsControllerHomepageAlbumsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>
  > = ({ signal }) => albumsControllerHomepageAlbums(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AlbumsControllerHomepageAlbumsQueryResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>
>;
export type AlbumsControllerHomepageAlbumsQueryError = ErrorType<unknown>;

export function useAlbumsControllerHomepageAlbums<
  TData = Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>,
          TError,
          Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useAlbumsControllerHomepageAlbums<
  TData = Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>,
          TError,
          Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAlbumsControllerHomepageAlbums<
  TData = Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get curated homepage albums
 */

export function useAlbumsControllerHomepageAlbums<
  TData = Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerHomepageAlbums>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAlbumsControllerHomepageAlbumsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get album details
 */
export const albumsControllerAlbumDetail = (
  params?: AlbumsControllerAlbumDetailParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DetailAlbumDto>(
    { url: `/albums/detail`, method: "GET", params, signal },
    options,
  );
};

export const getAlbumsControllerAlbumDetailQueryKey = (
  params?: AlbumsControllerAlbumDetailParams,
) => {
  return [`/albums/detail`, ...(params ? [params] : [])] as const;
};

export const getAlbumsControllerAlbumDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof albumsControllerAlbumDetail>>,
  TError = ErrorType<unknown>,
>(
  params?: AlbumsControllerAlbumDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAlbumsControllerAlbumDetailQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumDetail>>
  > = ({ signal }) =>
    albumsControllerAlbumDetail(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AlbumsControllerAlbumDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumDetail>>
>;
export type AlbumsControllerAlbumDetailQueryError = ErrorType<unknown>;

export function useAlbumsControllerAlbumDetail<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumDetail>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | AlbumsControllerAlbumDetailParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof albumsControllerAlbumDetail>>,
          TError,
          Awaited<ReturnType<typeof albumsControllerAlbumDetail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useAlbumsControllerAlbumDetail<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumDetail>>,
  TError = ErrorType<unknown>,
>(
  params?: AlbumsControllerAlbumDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof albumsControllerAlbumDetail>>,
          TError,
          Awaited<ReturnType<typeof albumsControllerAlbumDetail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAlbumsControllerAlbumDetail<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumDetail>>,
  TError = ErrorType<unknown>,
>(
  params?: AlbumsControllerAlbumDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get album details
 */

export function useAlbumsControllerAlbumDetail<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumDetail>>,
  TError = ErrorType<unknown>,
>(
  params?: AlbumsControllerAlbumDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAlbumsControllerAlbumDetailQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete an album
 */
export const albumsControllerAlbumDelete = (
  albumId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/albums/${albumId}`, method: "DELETE" },
    options,
  );
};

export const getAlbumsControllerAlbumDeleteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumDelete>>,
    TError,
    { albumId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumDelete>>,
  TError,
  { albumId: string },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumDelete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumDelete>>,
    { albumId: string }
  > = (props) => {
    const { albumId } = props ?? {};

    return albumsControllerAlbumDelete(albumId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumDelete>>
>;

export type AlbumsControllerAlbumDeleteMutationError = ErrorType<unknown>;

/**
 * @summary Delete an album
 */
export const useAlbumsControllerAlbumDelete = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumDelete>>,
      TError,
      { albumId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumDelete>>,
  TError,
  { albumId: string },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload album artwork
 */
export const albumsControllerAlbumUploadPicture = (
  albumId: string,
  albumsControllerAlbumUploadPictureBody: BodyType<AlbumsControllerAlbumUploadPictureBody>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, albumsControllerAlbumUploadPictureBody.file);

  return apiRequest<void>(
    {
      url: `/albums/${albumId}/picture`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getAlbumsControllerAlbumUploadPictureMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumUploadPicture>>,
    TError,
    { albumId: string; data: BodyType<AlbumsControllerAlbumUploadPictureBody> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumUploadPicture>>,
  TError,
  { albumId: string; data: BodyType<AlbumsControllerAlbumUploadPictureBody> },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumUploadPicture"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumUploadPicture>>,
    { albumId: string; data: BodyType<AlbumsControllerAlbumUploadPictureBody> }
  > = (props) => {
    const { albumId, data } = props ?? {};

    return albumsControllerAlbumUploadPicture(albumId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumUploadPictureMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumUploadPicture>>
>;
export type AlbumsControllerAlbumUploadPictureMutationBody =
  BodyType<AlbumsControllerAlbumUploadPictureBody>;
export type AlbumsControllerAlbumUploadPictureMutationError =
  ErrorType<unknown>;

/**
 * @summary Upload album artwork
 */
export const useAlbumsControllerAlbumUploadPicture = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumUploadPicture>>,
      TError,
      {
        albumId: string;
        data: BodyType<AlbumsControllerAlbumUploadPictureBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumUploadPicture>>,
  TError,
  { albumId: string; data: BodyType<AlbumsControllerAlbumUploadPictureBody> },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumUploadPictureMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete album artwork
 */
export const albumsControllerAlbumDeletePicture = (
  albumId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/albums/${albumId}/picture`, method: "DELETE" },
    options,
  );
};

export const getAlbumsControllerAlbumDeletePictureMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumDeletePicture>>,
    TError,
    { albumId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumDeletePicture>>,
  TError,
  { albumId: string },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumDeletePicture"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumDeletePicture>>,
    { albumId: string }
  > = (props) => {
    const { albumId } = props ?? {};

    return albumsControllerAlbumDeletePicture(albumId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumDeletePictureMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumDeletePicture>>
>;

export type AlbumsControllerAlbumDeletePictureMutationError =
  ErrorType<unknown>;

/**
 * @summary Delete album artwork
 */
export const useAlbumsControllerAlbumDeletePicture = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumDeletePicture>>,
      TError,
      { albumId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumDeletePicture>>,
  TError,
  { albumId: string },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumDeletePictureMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Presign a video upload to the VOD source bucket (admin/owner)
 */
export const albumsControllerAlbumPresignVideoUpload = (
  albumId: string,
  albumVideoPresignRequestDto: BodyType<AlbumVideoPresignRequestDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AlbumVideoPresignResponseDto>(
    {
      url: `/albums/${albumId}/videos/presign-upload`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: albumVideoPresignRequestDto,
      signal,
    },
    options,
  );
};

export const getAlbumsControllerAlbumPresignVideoUploadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumPresignVideoUpload>>,
    TError,
    { albumId: string; data: BodyType<AlbumVideoPresignRequestDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumPresignVideoUpload>>,
  TError,
  { albumId: string; data: BodyType<AlbumVideoPresignRequestDto> },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumPresignVideoUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumPresignVideoUpload>>,
    { albumId: string; data: BodyType<AlbumVideoPresignRequestDto> }
  > = (props) => {
    const { albumId, data } = props ?? {};

    return albumsControllerAlbumPresignVideoUpload(
      albumId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumPresignVideoUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumPresignVideoUpload>>
>;
export type AlbumsControllerAlbumPresignVideoUploadMutationBody =
  BodyType<AlbumVideoPresignRequestDto>;
export type AlbumsControllerAlbumPresignVideoUploadMutationError =
  ErrorType<unknown>;

/**
 * @summary Presign a video upload to the VOD source bucket (admin/owner)
 */
export const useAlbumsControllerAlbumPresignVideoUpload = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumPresignVideoUpload>>,
      TError,
      { albumId: string; data: BodyType<AlbumVideoPresignRequestDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumPresignVideoUpload>>,
  TError,
  { albumId: string; data: BodyType<AlbumVideoPresignRequestDto> },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumPresignVideoUploadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Register an uploaded video for processing (admin/owner)
 */
export const albumsControllerAlbumRegisterVideo = (
  albumId: string,
  registerAlbumVideoDto: BodyType<RegisterAlbumVideoDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AlbumVideoDto>(
    {
      url: `/albums/${albumId}/videos`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: registerAlbumVideoDto,
      signal,
    },
    options,
  );
};

export const getAlbumsControllerAlbumRegisterVideoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumRegisterVideo>>,
    TError,
    { albumId: string; data: BodyType<RegisterAlbumVideoDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumRegisterVideo>>,
  TError,
  { albumId: string; data: BodyType<RegisterAlbumVideoDto> },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumRegisterVideo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumRegisterVideo>>,
    { albumId: string; data: BodyType<RegisterAlbumVideoDto> }
  > = (props) => {
    const { albumId, data } = props ?? {};

    return albumsControllerAlbumRegisterVideo(albumId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumRegisterVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumRegisterVideo>>
>;
export type AlbumsControllerAlbumRegisterVideoMutationBody =
  BodyType<RegisterAlbumVideoDto>;
export type AlbumsControllerAlbumRegisterVideoMutationError =
  ErrorType<unknown>;

/**
 * @summary Register an uploaded video for processing (admin/owner)
 */
export const useAlbumsControllerAlbumRegisterVideo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumRegisterVideo>>,
      TError,
      { albumId: string; data: BodyType<RegisterAlbumVideoDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumRegisterVideo>>,
  TError,
  { albumId: string; data: BodyType<RegisterAlbumVideoDto> },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumRegisterVideoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List album videos with live processing status (admin/owner)
 */
export const albumsControllerAlbumListVideos = (
  albumId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AlbumVideoDto[]>(
    { url: `/albums/${albumId}/videos`, method: "GET", signal },
    options,
  );
};

export const getAlbumsControllerAlbumListVideosQueryKey = (
  albumId?: string,
) => {
  return [`/albums/${albumId}/videos`] as const;
};

export const getAlbumsControllerAlbumListVideosQueryOptions = <
  TData = Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>,
  TError = ErrorType<unknown>,
>(
  albumId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAlbumsControllerAlbumListVideosQueryKey(albumId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>
  > = ({ signal }) =>
    albumsControllerAlbumListVideos(albumId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!albumId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AlbumsControllerAlbumListVideosQueryResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>
>;
export type AlbumsControllerAlbumListVideosQueryError = ErrorType<unknown>;

export function useAlbumsControllerAlbumListVideos<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>,
  TError = ErrorType<unknown>,
>(
  albumId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>,
          TError,
          Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useAlbumsControllerAlbumListVideos<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>,
  TError = ErrorType<unknown>,
>(
  albumId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>,
          TError,
          Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAlbumsControllerAlbumListVideos<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>,
  TError = ErrorType<unknown>,
>(
  albumId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List album videos with live processing status (admin/owner)
 */

export function useAlbumsControllerAlbumListVideos<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>,
  TError = ErrorType<unknown>,
>(
  albumId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumListVideos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAlbumsControllerAlbumListVideosQueryOptions(
    albumId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Remove an album video (admin/owner)
 */
export const albumsControllerAlbumDeleteVideo = (
  albumId: string,
  albumMediaId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/albums/${albumId}/videos/${albumMediaId}`, method: "DELETE" },
    options,
  );
};

export const getAlbumsControllerAlbumDeleteVideoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumDeleteVideo>>,
    TError,
    { albumId: string; albumMediaId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumDeleteVideo>>,
  TError,
  { albumId: string; albumMediaId: string },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumDeleteVideo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumDeleteVideo>>,
    { albumId: string; albumMediaId: string }
  > = (props) => {
    const { albumId, albumMediaId } = props ?? {};

    return albumsControllerAlbumDeleteVideo(
      albumId,
      albumMediaId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumDeleteVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumDeleteVideo>>
>;

export type AlbumsControllerAlbumDeleteVideoMutationError = ErrorType<unknown>;

/**
 * @summary Remove an album video (admin/owner)
 */
export const useAlbumsControllerAlbumDeleteVideo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumDeleteVideo>>,
      TError,
      { albumId: string; albumMediaId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumDeleteVideo>>,
  TError,
  { albumId: string; albumMediaId: string },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumDeleteVideoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload album banner (used for featured display)
 */
export const albumsControllerAlbumUploadBanner = (
  albumId: string,
  albumsControllerAlbumUploadBannerBody: BodyType<AlbumsControllerAlbumUploadBannerBody>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, albumsControllerAlbumUploadBannerBody.file);

  return apiRequest<void>(
    {
      url: `/albums/${albumId}/banner`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getAlbumsControllerAlbumUploadBannerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumUploadBanner>>,
    TError,
    { albumId: string; data: BodyType<AlbumsControllerAlbumUploadBannerBody> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumUploadBanner>>,
  TError,
  { albumId: string; data: BodyType<AlbumsControllerAlbumUploadBannerBody> },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumUploadBanner"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumUploadBanner>>,
    { albumId: string; data: BodyType<AlbumsControllerAlbumUploadBannerBody> }
  > = (props) => {
    const { albumId, data } = props ?? {};

    return albumsControllerAlbumUploadBanner(albumId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumUploadBannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumUploadBanner>>
>;
export type AlbumsControllerAlbumUploadBannerMutationBody =
  BodyType<AlbumsControllerAlbumUploadBannerBody>;
export type AlbumsControllerAlbumUploadBannerMutationError = ErrorType<unknown>;

/**
 * @summary Upload album banner (used for featured display)
 */
export const useAlbumsControllerAlbumUploadBanner = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumUploadBanner>>,
      TError,
      {
        albumId: string;
        data: BodyType<AlbumsControllerAlbumUploadBannerBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumUploadBanner>>,
  TError,
  { albumId: string; data: BodyType<AlbumsControllerAlbumUploadBannerBody> },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumUploadBannerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete album banner
 */
export const albumsControllerAlbumDeleteBanner = (
  albumId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/albums/${albumId}/banner`, method: "DELETE" },
    options,
  );
};

export const getAlbumsControllerAlbumDeleteBannerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumDeleteBanner>>,
    TError,
    { albumId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumDeleteBanner>>,
  TError,
  { albumId: string },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumDeleteBanner"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumDeleteBanner>>,
    { albumId: string }
  > = (props) => {
    const { albumId } = props ?? {};

    return albumsControllerAlbumDeleteBanner(albumId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumDeleteBannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumDeleteBanner>>
>;

export type AlbumsControllerAlbumDeleteBannerMutationError = ErrorType<unknown>;

/**
 * @summary Delete album banner
 */
export const useAlbumsControllerAlbumDeleteBanner = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumDeleteBanner>>,
      TError,
      { albumId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumDeleteBanner>>,
  TError,
  { albumId: string },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumDeleteBannerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Add tracks to an album
 */
export const albumsControllerAlbumAddTracks = (
  albumId: string,
  addTracksToAlbumDto: BodyType<AddTracksToAlbumDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/albums/${albumId}/tracks`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addTracksToAlbumDto,
      signal,
    },
    options,
  );
};

export const getAlbumsControllerAlbumAddTracksMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumAddTracks>>,
    TError,
    { albumId: string; data: BodyType<AddTracksToAlbumDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumAddTracks>>,
  TError,
  { albumId: string; data: BodyType<AddTracksToAlbumDto> },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumAddTracks"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumAddTracks>>,
    { albumId: string; data: BodyType<AddTracksToAlbumDto> }
  > = (props) => {
    const { albumId, data } = props ?? {};

    return albumsControllerAlbumAddTracks(albumId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumAddTracksMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumAddTracks>>
>;
export type AlbumsControllerAlbumAddTracksMutationBody =
  BodyType<AddTracksToAlbumDto>;
export type AlbumsControllerAlbumAddTracksMutationError = ErrorType<unknown>;

/**
 * @summary Add tracks to an album
 */
export const useAlbumsControllerAlbumAddTracks = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumAddTracks>>,
      TError,
      { albumId: string; data: BodyType<AddTracksToAlbumDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumAddTracks>>,
  TError,
  { albumId: string; data: BodyType<AddTracksToAlbumDto> },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumAddTracksMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update tracks in an album reordering or updating promotional track
 */
export const albumsControllerUpdateAlbumTracks = (
  albumId: string,
  updateAlbumTracksDto: BodyType<UpdateAlbumTracksDto[]>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    {
      url: `/albums/${albumId}/tracks`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateAlbumTracksDto,
    },
    options,
  );
};

export const getAlbumsControllerUpdateAlbumTracksMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerUpdateAlbumTracks>>,
    TError,
    { albumId: string; data: BodyType<UpdateAlbumTracksDto[]> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerUpdateAlbumTracks>>,
  TError,
  { albumId: string; data: BodyType<UpdateAlbumTracksDto[]> },
  TContext
> => {
  const mutationKey = ["albumsControllerUpdateAlbumTracks"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerUpdateAlbumTracks>>,
    { albumId: string; data: BodyType<UpdateAlbumTracksDto[]> }
  > = (props) => {
    const { albumId, data } = props ?? {};

    return albumsControllerUpdateAlbumTracks(albumId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerUpdateAlbumTracksMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerUpdateAlbumTracks>>
>;
export type AlbumsControllerUpdateAlbumTracksMutationBody = BodyType<
  UpdateAlbumTracksDto[]
>;
export type AlbumsControllerUpdateAlbumTracksMutationError = ErrorType<unknown>;

/**
 * @summary Update tracks in an album reordering or updating promotional track
 */
export const useAlbumsControllerUpdateAlbumTracks = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerUpdateAlbumTracks>>,
      TError,
      { albumId: string; data: BodyType<UpdateAlbumTracksDto[]> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerUpdateAlbumTracks>>,
  TError,
  { albumId: string; data: BodyType<UpdateAlbumTracksDto[]> },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerUpdateAlbumTracksMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Remove a track from an album
 */
export const albumsControllerAlbumRemoveTrack = (
  albumId: string,
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/albums/${albumId}/tracks/${trackId}`, method: "DELETE" },
    options,
  );
};

export const getAlbumsControllerAlbumRemoveTrackMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumRemoveTrack>>,
    TError,
    { albumId: string; trackId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumRemoveTrack>>,
  TError,
  { albumId: string; trackId: string },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumRemoveTrack"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumRemoveTrack>>,
    { albumId: string; trackId: string }
  > = (props) => {
    const { albumId, trackId } = props ?? {};

    return albumsControllerAlbumRemoveTrack(albumId, trackId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumRemoveTrackMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumRemoveTrack>>
>;

export type AlbumsControllerAlbumRemoveTrackMutationError = ErrorType<unknown>;

/**
 * @summary Remove a track from an album
 */
export const useAlbumsControllerAlbumRemoveTrack = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumRemoveTrack>>,
      TError,
      { albumId: string; trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumRemoveTrack>>,
  TError,
  { albumId: string; trackId: string },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumRemoveTrackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List the track assets that can ship with this track on the album, flagged with whether they do (admin/owner)
 */
export const albumsControllerAlbumListTrackAssets = (
  albumId: string,
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AlbumTrackAssetOptionDto[]>(
    {
      url: `/albums/${albumId}/tracks/${trackId}/assets`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getAlbumsControllerAlbumListTrackAssetsQueryKey = (
  albumId?: string,
  trackId?: string,
) => {
  return [`/albums/${albumId}/tracks/${trackId}/assets`] as const;
};

export const getAlbumsControllerAlbumListTrackAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>,
  TError = ErrorType<unknown>,
>(
  albumId: string,
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAlbumsControllerAlbumListTrackAssetsQueryKey(albumId, trackId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>
  > = ({ signal }) =>
    albumsControllerAlbumListTrackAssets(
      albumId,
      trackId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(albumId && trackId),
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AlbumsControllerAlbumListTrackAssetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>
>;
export type AlbumsControllerAlbumListTrackAssetsQueryError = ErrorType<unknown>;

export function useAlbumsControllerAlbumListTrackAssets<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>,
  TError = ErrorType<unknown>,
>(
  albumId: string,
  trackId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>,
          TError,
          Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useAlbumsControllerAlbumListTrackAssets<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>,
  TError = ErrorType<unknown>,
>(
  albumId: string,
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>,
          TError,
          Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAlbumsControllerAlbumListTrackAssets<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>,
  TError = ErrorType<unknown>,
>(
  albumId: string,
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List the track assets that can ship with this track on the album, flagged with whether they do (admin/owner)
 */

export function useAlbumsControllerAlbumListTrackAssets<
  TData = Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>,
  TError = ErrorType<unknown>,
>(
  albumId: string,
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof albumsControllerAlbumListTrackAssets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAlbumsControllerAlbumListTrackAssetsQueryOptions(
    albumId,
    trackId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set the extra versions (instrumental, clean…) buyers get with this track on the album (admin/owner)
 */
export const albumsControllerAlbumSetTrackAssets = (
  albumId: string,
  trackId: string,
  setAlbumTrackAssetsDto: BodyType<SetAlbumTrackAssetsDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<AlbumTrackAssetOptionDto[]>(
    {
      url: `/albums/${albumId}/tracks/${trackId}/assets`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: setAlbumTrackAssetsDto,
    },
    options,
  );
};

export const getAlbumsControllerAlbumSetTrackAssetsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumSetTrackAssets>>,
    TError,
    {
      albumId: string;
      trackId: string;
      data: BodyType<SetAlbumTrackAssetsDto>;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumSetTrackAssets>>,
  TError,
  { albumId: string; trackId: string; data: BodyType<SetAlbumTrackAssetsDto> },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumSetTrackAssets"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumSetTrackAssets>>,
    { albumId: string; trackId: string; data: BodyType<SetAlbumTrackAssetsDto> }
  > = (props) => {
    const { albumId, trackId, data } = props ?? {};

    return albumsControllerAlbumSetTrackAssets(
      albumId,
      trackId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumSetTrackAssetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumSetTrackAssets>>
>;
export type AlbumsControllerAlbumSetTrackAssetsMutationBody =
  BodyType<SetAlbumTrackAssetsDto>;
export type AlbumsControllerAlbumSetTrackAssetsMutationError =
  ErrorType<unknown>;

/**
 * @summary Set the extra versions (instrumental, clean…) buyers get with this track on the album (admin/owner)
 */
export const useAlbumsControllerAlbumSetTrackAssets = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumSetTrackAssets>>,
      TError,
      {
        albumId: string;
        trackId: string;
        data: BodyType<SetAlbumTrackAssetsDto>;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumSetTrackAssets>>,
  TError,
  { albumId: string; trackId: string; data: BodyType<SetAlbumTrackAssetsDto> },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumSetTrackAssetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Publish an album
 */
export const albumsControllerAlbumPublish = (
  albumId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/albums/${albumId}/publish`, method: "POST", signal },
    options,
  );
};

export const getAlbumsControllerAlbumPublishMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumPublish>>,
    TError,
    { albumId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumPublish>>,
  TError,
  { albumId: string },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumPublish"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumPublish>>,
    { albumId: string }
  > = (props) => {
    const { albumId } = props ?? {};

    return albumsControllerAlbumPublish(albumId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumPublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumPublish>>
>;

export type AlbumsControllerAlbumPublishMutationError = ErrorType<unknown>;

/**
 * @summary Publish an album
 */
export const useAlbumsControllerAlbumPublish = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumPublish>>,
      TError,
      { albumId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumPublish>>,
  TError,
  { albumId: string },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumPublishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Unpublish an album
 */
export const albumsControllerAlbumUnpublish = (
  albumId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/albums/${albumId}/publish`, method: "DELETE" },
    options,
  );
};

export const getAlbumsControllerAlbumUnpublishMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof albumsControllerAlbumUnpublish>>,
    TError,
    { albumId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof albumsControllerAlbumUnpublish>>,
  TError,
  { albumId: string },
  TContext
> => {
  const mutationKey = ["albumsControllerAlbumUnpublish"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof albumsControllerAlbumUnpublish>>,
    { albumId: string }
  > = (props) => {
    const { albumId } = props ?? {};

    return albumsControllerAlbumUnpublish(albumId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlbumsControllerAlbumUnpublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof albumsControllerAlbumUnpublish>>
>;

export type AlbumsControllerAlbumUnpublishMutationError = ErrorType<unknown>;

/**
 * @summary Unpublish an album
 */
export const useAlbumsControllerAlbumUnpublish = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof albumsControllerAlbumUnpublish>>,
      TError,
      { albumId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof albumsControllerAlbumUnpublish>>,
  TError,
  { albumId: string },
  TContext
> => {
  const mutationOptions =
    getAlbumsControllerAlbumUnpublishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
